import { gql, useMutation } from '@apollo/client';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { Link } from 'react-router-dom';

import { FormInput, FormPanel } from 'components/FormPanel';

import pngLogo from 'media/pngLogo.png';

import { storeLoginCredentials } from 'utils/auth';

import theme from './theme.module.scss';

const FORGOT_PASSWORD_MUTATION = gql`
  mutation SignUpOnForgotPassword(
    $email: String!
    $password: String!
    $firstName: String!
    $lastName: String!
  ) {
    signup(email: $email, password: $password, firstName: $firstName, lastName: $lastName) {
      token
      user {
        id
        fullName
      }
    }
  }
`;

const Signup: FC = () => {
  const navigate = useNavigate();
  const [forgotPassword, { error, loading }] = useMutation(FORGOT_PASSWORD_MUTATION);

  return (
    <div className={theme.container}>
      <div className={theme.inner}>
        <NavLink to="/login" className={theme.logoContainer}>
          <img className={theme.logo} src={pngLogo} alt="PNG logo" height={64} />{' '}
          <span>Employees Directory</span>
        </NavLink>
        <h2>Reset Password using Email</h2>
        <FormPanel
          loading={loading}
          error={error}
          onSubmit={formData => {
            // call forgot password mutation here
          }}
          submitButtonLabel="Reset Now"
        >
          <FormInput fieldName="email" type="string" defaultValue="" label="Email" fullWidth />
        </FormPanel>
        <p className={theme.information}>
          Go back? <Link to="/login">Sign in</Link>
        </p>
      </div>
    </div>
  );
};

export default Signup;
